export default "<canvas id=\"alertChart\" style=\"width: 100%;\"></canvas>";